import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LeafPage} from './leaf.page';

const routes: Routes = [
  {
    path: '',
    component: LeafPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeafPageRoutingModule {
}
